export interface EstimationWizardState {
  activeStep: ReducerActiveStep;
  isActive: boolean;
  wizardSteps: IEstimationWizardStep[];
}

export type ReducerActiveStep = [number, number?];

export enum eActionTypes {
  SET_ACTIVE_STEP = 'SET_ACTIVE_STEP',
  SET_IS_WIZARD_VISIBLE = 'SET_IS_WIZARD_VISIBLE',
  SET_WIZARD_STEPS = 'SET_WIZARD_STEPS',
  CANCEL_WIZARD = 'CANCEL_WIZARD',
}

export interface IEstimationsWizardActions {
  setActiveStep: (payload: ReducerActiveStep) => void;
  setWizardVisible: (payload: boolean) => void;
  setWizardSteps: (payload: IEstimationWizardStep[]) => void;
  cancelWizard: () => void;
}

export type Actions =
  | { type: eActionTypes.SET_ACTIVE_STEP; payload: ReducerActiveStep }
  | { type: eActionTypes.SET_IS_WIZARD_VISIBLE; payload: boolean }
  | { type: eActionTypes.SET_WIZARD_STEPS; payload: IEstimationWizardStep[] }
  | { type: eActionTypes.CANCEL_WIZARD };

export const initWizardState: EstimationWizardState = {
  activeStep: [0, 0],
  isActive: false,
  wizardSteps: [],
};

export type EstimationStepGroup = 'create' | 'wizard';

export interface IEstimationWizardStep {
  label: string;
  link?: string;
  contentId: string;
  children?: IEstimationWizardStep[];
  isOmitted?: boolean;
  ignoreNumbering?: boolean;
  group?: EstimationStepGroup;
}
